import { SearchResultGroup } from "./types";
import { NAV_GROUPS } from "~/components/SidebarLayout/consts";

// // // //

/**
 * Generate SearchResultGroup from NAV_GROUPS
 * This keeps the page routing options in GlobalSearch + CommandPalette synced with the global navigation
 */
export const NAV_SEARCH_RESULT_GROUPS: SearchResultGroup[] = NAV_GROUPS.map(
    (navGroup) => {
        return {
            content: { label: navGroup.label || "Pages" },
            featureFlag: navGroup.featureFlag,
            items: navGroup.items
                .flatMap((item) => [item, ...(item.items ?? [])])
                .filter((item) => {
                    return item.external !== true && item.href !== undefined;
                })
                .map((item) => {
                    return {
                        href: item.href as string,
                        featureFlag: item.featureFlag,
                        content: {
                            label: item.label,
                            icon: item.icon,
                            iconClassName: item.iconClassName,
                        },
                    };
                }),
        };
    },
);
